// What a Send did, in words: where the draft is, and any receipt that went as
// a reduced copy (never silent).
import { mailboxLabel } from './receiptsApi';

export default function SendResult({ result, onClose }) {
  if (!result) return null;
  const reduced = (result.receipts || []).filter((r) => r.reduced);
  return (
    <div className="rc-panel" style={{ borderColor: '#bfe0c8', background: '#f3faf5' }} role="status">
      <div style={{ fontSize: '0.86rem', color: '#1f6b3a', fontWeight: 600 }}>
        Draft is in {mailboxLabel(result.mailbox)}, Drafts folder. Nothing was sent.
      </div>
      <div className="rc-note">{(result.receipts || []).length} receipt{(result.receipts || []).length === 1 ? '' : 's'} attached. Add who it goes to, then send it from Outlook.</div>
      {reduced.length > 0 && (
        <div className="rc-note" style={{ color: '#8a5a00' }}>
          Sent as a reduced copy to fit: {reduced.map((r) => r.id).join(', ')}. The draft says so; the original stays on file.
        </div>
      )}
      <div style={{ marginTop: 6, display: 'flex', gap: 8 }}>
        {result.webLink && <a className="rc-anchor" href={result.webLink} target="_blank" rel="noopener noreferrer">Open draft</a>}
        {onClose && <button type="button" className="rc-anchor" onClick={onClose}>Close</button>}
      </div>
    </div>
  );
}
